import { App } from "vue"
import { getUserPermissions } from "@/services-handlers/getUserPermissions"
import IPermission from "@/types/IPermissions"
import { RouteLocationRaw } from "vue-router"

export function provide(app: App): void {
  const permission: IPermission = {
    has: (permission: string): boolean =>
      getUserPermissions.hasPermission(permission),
    hasAll: (permissions: string[]): boolean =>
      getUserPermissions.hasAllPermissions(permissions),
    hasAny: (permissions: string[]): boolean =>
      getUserPermissions.hasAnyPermission(permissions),
    canAccessRoute: (route: RouteLocationRaw): boolean =>
      getUserPermissions.canAccessRoute(route),
    canAccessCustomerSearch: (): boolean =>
      getUserPermissions.hasCustSearchPermission(),
  }

  app.provide<IPermission>("$permission", permission)
}
